import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HomePage from "./pages/Home";
import ServicesPage from "./pages/Services";
import HowItWorksPage from "./pages/HowItWorks";
import ReviewsPage from "./pages/Reviews";
import GalleryPage from "./pages/Gallery";
import ContactPage from "./pages/Contact";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

const PAGE_META = {
  "/": { title: "Abid Home Solutions — Quality Work. Fair Pricing. Clean Results.", desc: "Local handyman services in Montgomery County, Frederick, Washington DC, McLean, Alexandria. TV mounting, furniture assembly, appliance installation, fitness equipment assembly, and moving help." },
  "/services": { title: "Services — Abid Home Solutions", desc: "TV mounting, furniture assembly, fitness equipment assembly, appliance installation, curtain/picture/mirror hanging, play equipment assembly, moving help, and basic home repairs near Gaithersburg, MD (20878)." },
  "/how-it-works": { title: "How It Works — Abid Home Solutions", desc: "Three simple steps: request a free estimate, quick call or text, then schedule and get it done." },
  "/reviews": { title: "Reviews — Abid Home Solutions", desc: "5-star reviews from local customers in Montgomery County and nearby areas." },
  "/gallery": { title: "Our Work — Abid Home Solutions", desc: "Project photos from TV mounting, furniture assembly, appliance installation and more." },
  "/contact": { title: "Request a Free Estimate — Abid Home Solutions", desc: "Tell us about your project. Free estimates, no commitment required. Call or text (227) 277-2112." },
};

function MetaUpdater() {
  const { pathname } = useLocation();
  useEffect(() => {
    const meta = PAGE_META[pathname] || PAGE_META["/"];
    document.title = meta.title;
    let tag = document.querySelector('meta[name="description"]');
    if (!tag) { tag = document.createElement("meta"); tag.setAttribute("name", "description"); document.head.appendChild(tag); }
    tag.setAttribute("content", meta.desc);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <MetaUpdater />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/how-it-works" element={<HowItWorksPage />} />
            <Route path="/reviews" element={<ReviewsPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="*" element={<HomePage />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
